import '../css/components.css'
import noticeComponent from "../../components/notice/notice";
import fundingSaveButtonsComponent from "../../components/funding-listing-component/funding-listing-component";
import singleEventsComponent from "../../components/single-events/single-events";

document.addEventListener('DOMContentLoaded', function() {
  fundingSaveButtonsComponent();
  noticeComponent();
  singleEventsComponent();
});
